import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AppContextProvider } from "./AppContext";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const rootElement = document.getElementById("root") as HTMLElement;
const baseUrlAttribute: string =
  rootElement.getAttribute("data-base-url") || "/";
const homeButtonLabel: string =
  rootElement.getAttribute("home-button-label") ||
  "Calculate Your Merchant Fees";

root.render(
  /* <React.StrictMode> */
  <AppContextProvider>
    <App
      baseUrlAttribute={baseUrlAttribute}
      homeButtonLabel={homeButtonLabel}
    />
  </AppContextProvider>
  /*   </React.StrictMode> */
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
